import { render, staticRenderFns } from "./registerZaxis.vue?vue&type=template&id=753ab486&scoped=true&"
import script from "./registerZaxis.vue?vue&type=script&lang=js&"
export * from "./registerZaxis.vue?vue&type=script&lang=js&"
import style0 from "./registerZaxis.vue?vue&type=style&index=0&id=753ab486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ab486",
  null
  
)

export default component.exports